// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"QuestionsList_pageHeader__JVVod"};